import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { styled } from '@mui/material/styles';
import GridToolbarCustom from './GridToolbarCustom';
import { Box, Typography } from "@mui/material";
const INITIAL_STATE = ({ page, pageSize, pageSizeOptionList }) => ({
  page,
  pageSize,
  pageSizeOptionList,
});
export default function CustomDataGrid(props) {
  //const [filt, setFilt] = useState([])
  const MyFilterAltIcon = styled(FilterAltIcon)({
    color: 'white',
  });
  const [selectionModel, setSelectionModel] = useState([]);
  const {
    getRowId = "",
    rows = "",
    title = "",
    columns = "",
    loading = false,
    pagination = true,
    paginationMode = "client",
    page = 0,
    pageSize = 20,
    pageSizeOptionList = [20, 50, 100],
    disableSelectionOnClick = true,
    onPageDataChange = (e) => e,
    rowCount,
    checkboxSelection = false,
    onSelectionModelChange = (e) => e,
    getRowClassName = (e) => e,
    // children,
  } = props;
  //console.log("CustomDataGrid",rows);
  /*const editColumns = columns.map((column) => ({
      
      field: column.data === '' ?  column.field : column.data,
      headerName: column.headerName,
      width:column.width,
      
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    }));*/
  //state
  const [state, setState] = useState(
    INITIAL_STATE({ page, pageSize, pageSizeOptionList })
  );

  /** Handlers */
  const onTablePageSizeChangeHandler = (size) => {
    setState((prevState) => ({ ...prevState, pageSize: size }));
  };

  const onTablePageChangeHandler = (number) => {
    setState((prevState) => ({ ...prevState, page: number }));
  };

  const getRowHeight = (rowIndex, columnIndex) => {
    // Get the content of the cell.
    const cellContent = rows[rowIndex][columnIndex];
    // Calculate the height of the cell.
    const height = cellContent.length * 16;
    // Return the height.
    return height;
  };

  useEffect(() => {
    (async () => {
      await onPageDataChange({ page: state.page, pageSize: state.pageSize });
    })();
  }, [state.pageSize, state.page]);

  function DataGridTitle() {
    return (
      <Box style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Typography variant="h5">{title}</Typography>
      </Box>
    )
  }

  return (
    <>
      <Box sx={{
        height: 480,
        width: "100%",
        marginTop: "1%",
      }}>
        <DataGrid
          getRowId={getRowId}
          rows={rows}
          columns={columns}
          slots={{
            toolbar: DataGridTitle
          }}
          getRowClassName={getRowClassName}
          //  getRowHeight={() => 'auto'} 
          // getEstimatedRowHeight={() => 200}
          pagination={pagination}
          paginationMode={paginationMode}
          page={state.page}
          onPageChange={onTablePageChangeHandler}
          pageSize={state.pageSize}
          onPageSizeChange={onTablePageSizeChangeHandler}
          rowCount={rowCount || (rows || []).length}
          rowsPerPageOptions={state.pageSizeOptionList}
          disableSelectionOnClick={disableSelectionOnClick}
          isCellEditable={() => false}
          experimentalFeatures={{ newEditingApi: true }}
          loading={loading}
          checkboxSelection={checkboxSelection}
          components={{
            ColumnMenuIcon: MyFilterAltIcon,
            Toolbar: GridToolbarCustom
          }}
          componentsProps={{
            toolbar: {
              selectionModel,
            },
          }}
          // filterModel={{
          //     items: filt
          //   }}
          onSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
          sx={{
            boxShadow: 15,
            border: 2,
            borderRadius: 3,
            borderColor: 'primary.paperborder',
            backgroundColor: "background.paper",
            '& .MuiDataGrid-cell:hover': {
              color: 'brown',
              backgroundColor: 'lightbrown',
              fontWeight: 'bold',
              border: '2px solid #00333e',
              borderRadius: 2,
            },
            '& .MuiDataGrid-columnHeaders': {
              // backgroundColor:'primary.datagridCol',
              backgroundColor: 'brown',
              color: 'white',
              fontFamily: '"Nunito", sans-serif',
            },

          }}

        />
      </Box>
    </>
  );
};